import React from 'react'

const CreateNotification = ({ onSend, inputValue, handleOnChange }) => {

  return (
    <>
      <div className="p-4 border bg-white rounded-md bg-whit h-full">
        <h2 className="text-lg font-semibold mb-4">Create Notification</h2>
        <form onSubmit={onSend}>
          <input type="text" placeholder="Title here" value={inputValue?.title} name="title" onChange={handleOnChange} required className="w-full mb-4 p-2 border rounded focus:outline-none focus:ring border-gray-300" />

          <textarea placeholder="Write here" value={inputValue?.desc} name="desc" onChange={handleOnChange} required className="w-full mb-4 p-2 border rounded focus:outline-none focus:ring border-gray-300" rows="4"></textarea>

          <button type="submit" className="bgbtn text-white py-2 px-4 rounded w-full">Send</button>
        </form>
      </div>
    </>
  )
}

export default CreateNotification